import { Component, Input } from '@angular/core';

@Component({
    selector: 'xm-broadband-header',
    styleUrls: ['./fcc-broadband-header.scss'],
    templateUrl: './fcc-broadband-header.html',
    standalone: false
})
export class XmBroadbandHeaderComponent  {
    @Input() public cbmLabelContent: CBMLabelDetails;
    @Input() public isGrandFatheredLabel: boolean;
    @Input() public infoIconGrey: MediaImageOptions;
}
